
import {throwError as observableThrowError,  Subject ,  Observable } from 'rxjs';

import {refCount, publishReplay, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Alert } from '../models/common-model-interface';
//import { AlertsCountService } from './alerts-count.service';
const NUMBER_OF_DAYS = 180;
const ALERT_API_LOCAL = '/json/alerts.json';
const ALERT_DETAIL_LOCAL = '/json/alert-detail.json/';
const ALERT_DETAIL_URL = '/sec/api/alertmessages/';
const ALERT_API_URL = '/sec/api/alerts?details=false&channel=inbox';

const ALERT_API_UPDATE = '/sec/api/messageread';
export interface IAlertsService { }

export enum AlertActions {
  MARK_AS_READ = 1,
  GET_NEW = 2
}

export interface IAlertNotification {
  alerts?: Array<Alert>;
  action: AlertActions;
}

export interface IAlertsQueryParams {
  channel?: string;
  page?: number;
  deleted?: boolean;
  size?: number;
  sortedfield?: string;
  sortorder?: string;
  detail?: string;
  readcount?: number;
}

@Injectable()
export class AlertsService implements IAlertsService {
  static customApiEndpoint: string = null;
  static customMessageReadEndpoint: string = null;

  /**
   * Allow consumers ability to specify custom endpoint
   * @param customApiEndPoint
   */
  public static setCustomApiEndpoint(customApiEndPoint: string): void {
    AlertsService.customApiEndpoint = customApiEndPoint;
  }

  private alertSubject = new Subject<IAlertNotification>();
  alertsNotification$ = this.alertSubject.asObservable();
  private alertDetailCache = {};
  alertCount: number;

  //constructor(private http: Http, private alertsCountService: AlertsCountService) { }

  constructor(private http: Http) { }

  getDateRange(date: Date) {
    let day = date.getDate();
    let monthIndex = date.getMonth() + 1;
    let year = date.getFullYear();
    return year + '-' + monthIndex + '-' + day;
  }

  getAlerts(domain: string, AlertsQuery?: IAlertsQueryParams): Observable<any> {
    const ALERT_URL = /localhost/.test(domain) ? ALERT_API_LOCAL : ALERT_API_URL;
    var validateCount = false;

    let date = new Date();
    let currentDate = this.getDateRange(date);

    let endDate = new Date();
    endDate.setDate(date.getDate() - NUMBER_OF_DAYS);
    let finalEndDate = this.getDateRange(endDate);

    const dateRange = 'sendtimebetween=' + finalEndDate + ',' + currentDate;
    const alertUrl = AlertsService.customApiEndpoint || ALERT_URL;

    const finalAlertUrl = alertUrl + (alertUrl.includes('?') ? '&' : '?') + `${dateRange}`;

    const options = this.buildRequestOptions({}, AlertsQuery);
    const notification: IAlertNotification = {
      action: AlertActions.GET_NEW
    };

    return this.http
      .get(finalAlertUrl + (finalAlertUrl.includes('?') ? '&' : '?') + Date.now(), options).pipe(
      map((response: Response) => {
        const alerts: Array<Alert> = response.json().body.listUserAlertDistributionDTO as Array<
          Alert
          >;
        notification.alerts = alerts;
        this.alertSubject.next(notification);

        if (AlertsQuery) {
          validateCount = AlertsQuery.readcount === 0 ? true : false;
        }
        if (validateCount) {
          this.alertCount = response.json().body.count;
        }
        return response.json();
      }),
      catchError(this.handleError),
      publishReplay(1),
      refCount(),);
  }

  requestAlertDetail(domain: string, alertId): Observable<any> {
    //const dmn = domain ? domain : 'http://localhost:8080';

    const DETAIL_URL = /localhost/.test(domain) ? ALERT_DETAIL_LOCAL : ALERT_DETAIL_URL;
    const finalAlertUrl = `${domain + DETAIL_URL + alertId}`;

    if (!this.alertDetailCache[alertId]) {
      // create observable, cache and return
      this.alertDetailCache[alertId] = this.http
        .get(finalAlertUrl, { withCredentials: true }).pipe(
        map((res: Response) => {
          return res.json();
        }),
        // .delay(2000)
        catchError(this.handleError),
        publishReplay(1),
        refCount(),);
    }

    return this.alertDetailCache[alertId];
  }

  dismissAlert(domain: string, alert: Alert): void {
    //const dmn = domain ? domain : 'http://localhost:8080';

    let finalAlertUrl;
    if(AlertsService.customMessageReadEndpoint){
      finalAlertUrl = AlertsService.customMessageReadEndpoint
    }else {
      finalAlertUrl = `${domain + ALERT_API_UPDATE}`;
    }

    let headers: Headers = new Headers();

    if (alert.readCount === 0) {
      this.alertCount = this.alertCount - 1; // @todo remove this line once alertCount service is working with filters
      //this.alertsCountService.count = this.alertsCountService.count - 1;
    }

    const notification: IAlertNotification = {
      action: AlertActions.MARK_AS_READ
    };

    notification.alerts = new Array<Alert>();
    notification.alerts.push(alert);

    this.alertSubject.next(notification);
    //let url = '/alerts/v1/alertmessages/messageread';

    //let url = this.getUrl(uri);

    const payload = { ids: [alert.userAlertDistributionID] };
    const body: string = JSON.stringify(payload);
    headers.append('Content-Type', 'application/json');

    this.http
      .put(finalAlertUrl, body, {
        headers: headers,
        withCredentials: true
      }).pipe(
      map(res => {
        if (res.status < 200 || res.status >= 300) {
          return res;
        } else {
          return res.json();
        }
      }),
      catchError(this.handleError),
      publishReplay(1),
      refCount(),)
      .subscribe(data => {
        console.log(data);
      });
  }

  private handleError(error: Response): Observable<any> {
    console.error(error);
    const msg = `Error status code ${error.status} at ${error.url}`;

    return observableThrowError(msg);
  }

  private buildRequestOptions(headers: any, search: any): RequestOptions {
    const myHeaders = new Headers();

    // myHeaders.append('Content-Type', 'application/json');

    Object.keys(headers).forEach(key => myHeaders.append(key, search[key]));

    const myParams = new URLSearchParams();
    Object.keys(search).forEach(key => myParams.append(key, search[key]));

    const options = new RequestOptions({
      headers: myHeaders,
      search: myParams,
      withCredentials: true
    });

    return options;
  }
}
